import { render, staticRenderFns } from "./HeroDropdown.vue?vue&type=template&id=7bc950c8&scoped=true&"
import script from "./HeroDropdown.vue?vue&type=script&lang=js&"
export * from "./HeroDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bc950c8",
  null
  
)

export default component.exports